export default "__VITE_ASSET__BO1H89$5__"